import VideoListItem from './video_list_item';

const VideoListBrand = ({ brand, brandVideos }) => {
  const brandImage = brandVideos[0].Image;

  return (
    <>
      <h4 className="how-to-guides__brand-title">
        <span className="hide-text">{brand}</span>
        {brandImage ? (
          <img className="how-to-guides__brand-logo" src={brandImage} alt="" />
        ) : (
          <span className="how-to-guides__title news__title">{brand}</span>
        )}
      </h4>

      <ul className="yt-list no-bullet fl fw-w jc-c m-jc-fs l-jc-fs">
        {brandVideos.map((item, k) => (
          <li className="yt-list__item" key={k}>
            <VideoListItem item={item} />
          </li>
        ))}
      </ul>
    </>
  );
};

export default VideoListBrand;
